import React, {useEffect, useState} from 'react';
import _ from "lodash";
import {XMarkIcon} from "@heroicons/react/24/solid";

const SelectThemes = ({
                          allThemes,
                          existingThemes,
                          handleSelectThemesChanges,
                          showClearSelectedThemes,
                          showClearSelectedThemesIcon
                      }) => {
    const [searchText, setSearchText] = useState('');
    const [filteredThemesList, setFilteredThemesList] = useState(allThemes);
    const [selectedThemes, setSelectedThemes] = useState([]);

    useEffect(() => {
        setSelectedThemes(existingThemes);
        prepareFilteredThemesList();
    }, [existingThemes]);

    const toggleThemeSelection = (themeItem) => {
        themeItem.selected = !themeItem.selected;

        let existingSelectedThemes = []

        if (!_.isEmpty(selectedThemes)) {
            existingSelectedThemes = [...selectedThemes];
        }

        if (existingSelectedThemes.indexOf(themeItem.id) === -1) {
            existingSelectedThemes.push(themeItem.id);
        } else {
            existingSelectedThemes = _.filter(existingSelectedThemes, (existingTheme) => {
                return existingTheme !== themeItem.id;
            });
        }

        const event = {
            target: {
                name: 'themeList',
                value: existingSelectedThemes
            }
        };

        setSelectedThemes(existingSelectedThemes);
        handleSelectThemesChanges(event);
        clearFiltersAfterSelection();
    }

    const clearFiltersAfterSelection = () => {
        const existingFilteredThemesList = [...filteredThemesList];

        if (existingFilteredThemesList.length <= 1 && searchText) {
            setSearchText('');
        }
    }

    const handleClearSearch = () => {
        setSearchText('');
    }

    const handleSearchText = (event) => {
        setSearchText(_.toLower(event.target.value));
    }

    const clearSelectedThemes = () => {
        const tempSelectedThemes = [];
        const event = {
            target: {
                name: 'themeList',
                value: tempSelectedThemes
            }
        };

        setSelectedThemes(tempSelectedThemes);
        handleSelectThemesChanges(event);
        prepareFilteredThemesList();
    }

    useEffect(() => {
        prepareFilteredThemesList();
    }, [searchText]);

    const prepareFilteredThemesList = () => {
        let existingSelectedThemes = existingThemes || [];

        const updatedFilteredThemesList = searchText ? [] : allThemes;

        _.forEach(allThemes, theme => {
            theme.selected = existingSelectedThemes.indexOf(theme.id) !== -1;

            if (theme.textList.indexOf(searchText) !== -1) {
                updatedFilteredThemesList.push(theme);
            }
        });

        setFilteredThemesList(_.orderBy(updatedFilteredThemesList, ['selected', 'startText'], ['desc', 'asc']));
    }

    return (
        <>
            <div className="flex justify-start w-full sticky top-0 bg-blue-100 border-b border-blue-400">
                <div className="field-group-container">

                    <div className="field-container">
                        <input
                            placeholder="Search Themes"
                            type="text"
                            className="input-field-medium"
                            id="searchText"
                            name="searchText"
                            value={searchText}
                            onChange={handleSearchText}>
                        </input>
                    </div>

                    {searchText &&

                        <button
                            onClick={() => handleClearSearch()}
                            className="rounded -ml-11 flex items-center justify-center border-gray-500 bg-white text-gray-500 hover:bg-gray-500 hover:text-white">
                            <div className="p-1">
                                <XMarkIcon className="h-6 w-6"/>
                            </div>
                        </button>
                    }

                    {(showClearSelectedThemes || showClearSelectedThemesIcon) && !searchText &&
                        <button
                            onClick={() => clearSelectedThemes()}
                            className="rounded ml-2 flex items-center justify-center border bg-red-100 text-red-500 border-red-500 hover:text-gray-700 hover:bg-white hover:border-gray-500">
                            {!showClearSelectedThemesIcon &&
                                <span className="py-2 px-4">Clear Selected Themes</span>
                            }
                            {showClearSelectedThemesIcon &&
                                <div className="p-1">
                                    <XMarkIcon className="h-6 w-6"/>
                                </div>
                            }
                        </button>
                    }

                </div>
            </div>

            <div className="flex flex-wrap m-2">
                {filteredThemesList?.map((themeItem, index) => (
                    <div key={index}>

                        {themeItem.selected &&
                            <button type="button"
                                    onClick={() => {
                                        toggleThemeSelection(themeItem)
                                    }}
                                    className="m-1 inline-block py-1 px-2 bg-blue-600 text-white font-medium leading-tight rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out">
                                {themeItem?.startText}
                            </button>
                        }

                        {!themeItem.selected &&
                            <button type="button"
                                    onClick={() => {
                                        toggleThemeSelection(themeItem)
                                    }}
                                    className="m-1 inline-block py-1 px-2 border border-gray-600 text-gray-600 font-medium leading-tight rounded hover:bg-black hover:bg-opacity-5 focus:outline-none focus:ring-0 transition duration-150 ease-in-out">
                                {themeItem?.startText}
                            </button>
                        }

                    </div>
                ))}
            </div>
        </>
    )
}

export default SelectThemes
